/**
 * AppBar Component Entry Point
 *
 * Re-exports the `AppBar` component and its props for easier imports.
 * This allows consumers to import from the component directory directly:
 * 
 * Example:
 * import { AppBar, AppBarProps } from "@geekyhawks/react-native-ui-components";
 *
 * Author: Geeky Hawks FZE LLC
 */

export { default as AppBar } from "./AppBar";
export type { Props as AppBarProps } from "./AppBar";
